/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {LocalidadeListComponent} from "./localidade-list/localidade-list.component";
import {LocalidadeFormComponent} from "./localidade-form/localidade-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class LocalidadesRoutingModule {}

export const localidadesRoutes: any[] = [
  {
    path: '',
    component: LocalidadeListComponent
  },{
    path: editRoute + '/:id',
    component: LocalidadeFormComponent
  },{
    path: newRoute,
    component: LocalidadeFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades-routing.module.ts
 **/